// extracted by mini-css-extract-plugin
export default {"file":"ViewConfirmDocument_file__qyKUQ","size":"ViewConfirmDocument_size__Qsjmk"};